// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.assignments-list[data-v-52b1be3d] {\n  display: block;\n  overflow: auto;\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  padding-bottom: 2px;\n  list-style-type: none;\n}\n.assignments-list__btn[data-v-52b1be3d] {\n  margin-top: 20px;\n  padding: 0 15px;\n}\n", ""]);
// Exports
module.exports = exports;
